import React, { } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
const ImagePlaceholderDetail = ({ className = '' }) => {
    return (
        <>
            <div className={`img-placeholder-dtl position-relative ${className}`}>
                <img className="img-fluid" src={require('../../../assets/img/img-placeholder-detail.png')} alt="Placeholder" />
                <span className="no-image d-inline-flex align-items-center justify-content-center position-absolute">
                    <FontAwesomeIcon icon={faImage} />
                </span>
            </div>
        </>
    )
};
export default ImagePlaceholderDetail;